<template>
  <div>
    <div class="input-group">
      <i class="icon iconfont" :class="icon" v-if="icon"></i>
      <input
        :placeholder="placeholder"
        :type="type"
        :value="value"
        class="reg-input"
        @input="$emit('input', $event.target.value)"
        autocomplete="off"
      >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputGroup",
  components: {},
  props: {
    icon: {
      type: String,
      default: ""
    },

    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.input-group {
  width: 100%;
  height: 40px;
  margin-bottom: 16px;
  border: 1px solid rgba(220, 220, 220, 1);
  border-radius: 0;
  display: flex;
  align-items: center;
  padding: 5px 0 5px 10px;
  box-sizing: border-box;
  .icon {
    display: inline-block;
    text-align: center;
    margin-right: 6px;
  }
  .reg-input {
    display: block;
    height: 100%;
    flex: 1;
  }
}
</style>